import { useTranslate } from '@growtherapy/i18n';
import { Alert, Button } from '@growtherapy/sprout-ui';

export type SeparateAccountCalloutProps = {
  contactUsUrl: string;
};

export function SeparateAccountCallout({ contactUsUrl }: SeparateAccountCalloutProps) {
  const t = useTranslate();

  return (
    <Alert
      use='info'
      icon={null}
      heading={t('telehealth-core:introRoom.wantASeparateAccount')}
      actions={
        <Button
          className='flex-shrink-0'
          onClick={() => {
            window.open(contactUsUrl, '_blank');
          }}
        >
          {t('telehealth-core:core.contactUs')}
        </Button>
      }
    >
      {t('telehealth-core:introRoom.givenYouAreNowOver18')}
    </Alert>
  );
}
